import { RootState } from "../../../../store";
import { resourceExplorerWidgetDataSelector } from "../resource-explorer-widget/resourceExplorerWidgetDataSelector";
import { ResourceExplorerCostsDateDetails } from "../../../../../services/cloudchipr.api";

export const resourceExplorerDataGridDataTotalCostDateDetailsSelector = (
  state: RootState,
): ResourceExplorerCostsDateDetails | undefined => {
  return resourceExplorerWidgetDataSelector(state)?.total_cost_date_details;
};
